module.exports = __webpack_public_path__ + "static/media/successCheck.5e586b2c.svg";